import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetNewSSOSetup = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean
): UseQueryResult<
  Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto | undefined,
  unknown
> => {
  const providerTypes = useQuery(
    ['getNewSSOSetup'],
    async () => {
      return await handleRequest(
        CompanySsoConfigurationService.getApiIdentityApiAppCompanySsoConfigurationNewSsoSetupInfo()
      );
    },
    {
      enabled,
    }
  );

  return providerTypes;
};

export default useGetNewSSOSetup;
